<nav aria-label="Search results pages">
  <ul class="pagination mb-0">
    <li *ngIf="pages.length > 1" class="page-item">
      <a [ngClass]="{'disabled-link': isBusy, 'page-link': 1 === 1}" (click)="goToPage(1)" href="javascript:void(0)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-bar-left align-middle" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M11.854 3.646a.5.5 0 0 1 0 .708L8.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 
            0-.708l4-4a.5.5 0 0 1 .708 0zM4.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"/>
        </svg>
      </a>
    </li>
    <li *ngIf="paginationDetails.currentpage > paginationDetails.rowsperpage" class="page-item">
      <a href="javascript:void(0)" [ngClass]="{'disabled-link': isBusy, 'page-link': 1 === 1}" 
        (click)="goToPage(paginationDetails.currentpage - paginationDetails.rowsperpage)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-left align-middle" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
          <path fill-rule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
        </svg>
      </a>
    </li>
    <li *ngIf="pages.length > 1" class="page-item">
      <a [ngClass]="{'disabled-link': isBusy, 'page-link': 1 === 1}" (click)="goToPage(paginationDetails.currentpage - 1)" href="javascript:void(0)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left align-middle" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
        </svg>
      </a>
    </li>
    <li *ngFor="let page of groupPages" class="page-item" [ngClass]="{'active': paginationDetails.currentpage === page }">
      <a [ngClass]="{'page-link': 1 === 1, 'disabled-link': isBusy }" 
        href="javascript:void(0)" (click)="goToPage(page)">
        {{ page }}
      </a>
    </li>
    <li *ngIf="paginationDetails.currentpage < pages.length" class="page-item">
      <a href="javascript:void(0)" [ngClass]="{'disabled-link': isBusy}" (click)="goToPage(paginationDetails.currentpage + 1)" class="page-link">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right align-middle" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </a>
    </li>
    <li *ngIf="paginationDetails.currentpage < pages.length" class="page-item">
      <a href="javascript:void(0)" [ngClass]="{'disabled-link': isBusy}" (click)="goToPage(paginationDetails.currentpage + paginationDetails.rowsperpage)" class="page-link">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right align-middle" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"/>
          <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </a>
    </li>
    <li *ngIf="pages.length > 1" class="page-item">
      <a href="javascript:void(0)" [ngClass]="{'disabled-link': isBusy, 'page-link': 1 === 1}" (click)="goToPage(pages.length)">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-bar-right align-middle" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0zM11.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"/>
        </svg>
      </a>
    </li>
  </ul>
</nav>